import { cyolistStore } from '@/stores/cyolist/cyolist';
import { setFilterFromRouteParam } from '~/utils/cyoHelper/cyoFilter.utils';

export function useFilterWatcherComposable(filter, options, moduleSubType) {
    const route = useRoute();
    const router = useRouter();
    const store = cyolistStore();

    watch(
        () => route.query[filter.value?.urlLabel],
        (newVal, oldVal) => {
            if (newVal === oldVal) return;

            if (!newVal) {
                resetFilterInStore();
                return;
            }

            if (filter.value.singleSelect) {
                const activeOption = options.value.find((opt) => opt.url === newVal);
                if (!activeOption) {
                    console.warn('No matching option found for:', newVal);
                    resetFilterInStore();
                    return;
                }
                return;
            }
        }
    );


    const toggleFilter = (value, reset = false) => {
        const urlLabel = filter.value.urlLabel;
        const activeQueryValue = route.query[urlLabel];
        const updatedQuery = { ...route.query };

        const matchedOption = options.value.find((opt) => opt.value === value);
        if (!matchedOption) {
            console.warn('No matching option found for value:', value);
            return;
        }
        console.log('  🚀  reset', reset, filter.value.urlLabel)

        let startWithPayload = {}

        // if reset is false and there is a start_with param in the route, set the start_with param to an empty string
        if (!reset && route.params.start_with) {

            startWithPayload = setFilterFromRouteParam(null, null, router)
        }

        // if filter is single select
        if (filter.value.singleSelect) {

            // remove the filter if reset is true and the active query value is the same as the matched option url
            if (reset || activeQueryValue === matchedOption.url) {
                delete updatedQuery[urlLabel];
            } else {
                updatedQuery[urlLabel] = matchedOption.url;
            }
        }

        // if filter is multi select
        if (!filter.value.singleSelect) {
            let routeValues = (typeof activeQueryValue === 'string') ? activeQueryValue.split(',').filter(Boolean) : [];
            const isSelected = routeValues.includes(matchedOption.url);
            routeValues = isSelected ? routeValues.filter((x) => x !== matchedOption.url) : [...routeValues, matchedOption.url];

            // add start with payload values to route values
            if (startWithPayload[urlLabel] !== undefined && !routeValues?.includes(startWithPayload[urlLabel])) {
                routeValues = [...routeValues, startWithPayload[urlLabel]]
            }

            if (reset) {
                routeValues = routeValues.filter((x) => x !== matchedOption.url)
            }

            if (routeValues.length === 0) {
                delete updatedQuery[urlLabel]
            } else {
                updatedQuery[urlLabel] = routeValues.join(',');
            }
        }

        // updatedQuery.page = 1;
        router.push({ params: { start_with: '' }, query: { ...startWithPayload, ...updatedQuery } });
    }

    /****
     * FUNCTION: Resets the filter in the store if the query was removed.
     ****/
    function resetFilterInStore() {
        return
        // Example: loop through options and set them inactive
        for (const opt of options.value) {
            if (opt.active === 1) {
                // store.toggleSettingFilter({
                //     reset: false,
                //     type: moduleSubType,
                //     filter: filter.value,
                //     option: { value: 0 },
                // });
            }
        }
    }
    return { toggleFilter };
}
